import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_BKqc0fddj1 from "/app/node_modules/nuxt-laravel-echo/dist/runtime/plugin.client.js";
import plugin_vfCt6Q18Tc from "/app/node_modules/nuxt-auth-sanctum/dist/runtime/plugin.js";
import plugin_sb2LSEEy8f from "/app/node_modules/nuxt-quasar-ui/dist/runtime/plugin.js";
import quasar_mqhBC93Gy3 from "/app/plugins/quasar.ts";
import ready_client_VDAUw9EeQx from "/app/plugins/ready.client.ts";
import vuetify_7h9QAQEssH from "/app/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_BKqc0fddj1,
  plugin_vfCt6Q18Tc,
  plugin_sb2LSEEy8f,
  quasar_mqhBC93Gy3,
  ready_client_VDAUw9EeQx,
  vuetify_7h9QAQEssH
]